<template>
  <van-dialog
    className="dialog"
    v-model="mShow"
    :showConfirmButton="false"
    :closeOnClickOverlay="true"
  >
    <div class="container column">
      <div class="content">
        <div class="tip left">大福神驾到，让你奖品翻倍拿</div>
        <div class="tip right">拼翻倍人品，最高十倍等你拿</div>

        <img style="height: 30px; margin-top: 30px" :src="topText" alt="" />
        <div class="circleContent">
          <img
            :class="['circleBig', isExpanding ? 'spining' : '']"
            src="../../assets/wheel/circle_big.png"
            alt=""
          />
          <img
            :class="['circleBig', isExpanding ? 'spining' : '', 'reverse']"
            class="circleSmall"
            src="../../assets//wheel/circle_small.png"
            alt=""
          />
          <div class="circleTextContent">
            <div class="circleT1">x</div>
            <div :class="['circleT2', isExpanding ? '' : 'breathing',isExpanded?'gold':'']">
              {{ currentNumber }}
            </div>
            <div class="circleT1">倍</div>
          </div>
        </div>

        <div class="t3">{{ btmText }}</div>
      </div>

      <div class="btn" @click="toExpanding">
        <img style="height: 25px" :src="btnText" alt="" />
      </div>
    </div>
  </van-dialog>
</template>

<script>
const text_rpbf = require("../../assets/wheel/text_rpbf.png");
const text_gxn = require("../../assets/wheel/text_gxn.png");
const text_kspz = require("../../assets/wheel/text_kspz.png");
const text_xzpzjl = require("../../assets/wheel/text_xzpzjl.png");

export default {
  data() {
    return {
      mShow: false,
      isExpanded: false,
      isExpanding: false,
      currentNumber: "?",
      intervalId: null,
      topText: text_rpbf,
      btmText: "最高可翻10倍",
      btnText: text_kspz,
      myExpandNumber: 0,
    };
  },

  mounted() {},

  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },

  methods: {
    open() {
      this.clear();
      this.mShow = true;
    },
    clear() {
      this.stopAnimation();
      this.currentNumber = 1;
      this.intervalId = null;
      this.isExpanding = false;
      this.currentNumber = "?";
      this.btnText = text_kspz;
      this.isExpanded = false;
      this.btmText = "最高可翻10倍";
    },

    close() {
      this.mShow = false;
      this.$emit("close");
    },
    changeExpand() {
      this.mShow = false;
      this.$emit("changeExpand");
    },

    toExpanding() {
      if (this.isExpanded) {
        this.changeExpand();
        return;
      }

      if (this.isExpanding) return;

      this.isExpanding = true;

      this.$request.POST({
        url: "activity/inflate/lottery",
        showLoading:false,
        success: (obj) => {
          this.myExpandNumber = obj;
          this.startAnimation();
          setTimeout(() => {
            this.stopAnimation();
            this.isExpanding = false;
            this.topText = text_gxn;
            this.currentNumber = this.myExpandNumber;
            this.btmText = `获得${this.myExpandNumber}倍奖励`;
            this.btnText = text_xzpzjl;
            this.isExpanded = true;
          }, 4000);

          this.$emit("expandNumberChange")
        },
      });
    },

    startAnimation() {
      this.stopAnimation();
      this.currentNumber = 1;
      this.intervalId = setInterval(() => {
        this.currentNumber++;
        if (this.currentNumber > 9) {
          this.currentNumber = 1;
        }
      }, 50); // 每100毫秒更新一次数字
    },
    stopAnimation() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
  },
};
</script>

<style scoped>
@import url(../../css/main.css);
.container {
  height: auto;
}
.content {
  position: relative;
  width: 100%;
  height: 380px;
  background-image: url(../../assets/wheel/dialog_bg_red.png);
  background-repeat: no-repeat;
  background-size: 100%;
}
.circleContent {
  margin-top: 10px;
  height: 200px;
  position: relative;
}

.circleBig {
  position: absolute;
  width: 190px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.spining {
  animation: spin 2s linear infinite; /* 动画名称，持续时间，速度曲线，是否重复 */
}
.reverse {
  animation-direction: reverse; /* 或者使用 alternate 来来回回地播放动画 */
}
.circleSmall {
  position: absolute;
  width: 150px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.circleTextContent {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.circleT1 {
  color: white;
  font-size: 22px;
  font-weight: 500;
  margin-top: 30px;
}
.circleT2 {
  color: white;
  font-size: 140px;
  font-weight: 1000;
}
.gold{
  color: #fff94a;
}

.t3 {
  font-family: HelloFont WenYiHei;
  font-weight: 1000;
  font-size: 36px;
  color: #ffffff;
  line-height: 60px;
}

.left {
  position: absolute;
  top: 40px;
  left: 20px;
}
.right {
  position: absolute;
  top: 40px;
  right: 20px;
}

.tip {
  font-family: Source Han Sans SC;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  opacity: 0.54;
  letter-spacing: 10px;
  writing-mode: vertical-rl; /* 从右向左垂直排列 */
  /* 或者 writing-mode: vertical-lr; 从左向右垂直排列 */
  text-orientation: upright; /* 文字保持水平 */
}

.dialog {
  background: none !important;
}

.btn {
  width: 250px;
  margin-top: 16px;
  height: 56px;
  background-image: url(../../assets/wheel/btn_bg.png);
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 定义一个名为 spin 的 keyframes 动画 */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.breathing {
  animation: breathe 2s ease-in-out infinite; /* 使用 breathe 动画，持续时间为2秒，无限循环 */
}
/* 定义一个名为 breathe 的 keyframes 动画 */
@keyframes breathe {
  0%,
  100% {
    transform: scale(1); /* 在动画开始和结束时恢复到原始大小 */
    opacity: 1; /* 不透明度恢复到初始状态 */
  }
  50% {
    transform: scale(0.8); /* 在中间点放大到1.2倍 */
    opacity: 1; /* 中间点时稍微降低不透明度 */
  }
}
</style>